/* global axios */
import ApiClient from './ApiClient';

class LLMChatbotAPI extends ApiClient {
  constructor() {
    super('llm_chatbots', { accountScoped: true });
  }

 // get all llm models
 getLLMModels(params={}) {
  return axios.get(`${this.url}/fetch_model`,);
 }

 // get all items
 getAllLLMChatbots(params={}) {
  return axios.get(`${this.url}`,{
    params: {
      ...params
    }
  });
 }

 // create new item
 createLLMChatbot(data) {
  return axios.post(`${this.url}`, data);
 }

 // update item
 updateLLMChatbot(id, data) {
  return axios.patch(`${this.url}/${id}`, data);
 }

 // delete item
 deleteLLMChatbot(id) {
  return axios.delete(`${this.url}/${id}`);
 }

 // get list of all llm assistants
 getLLMAssistantList(params={}){
  return axios.get(`${this.url}/lists`,{params});
 }

 // get single llm by id
 fetchLLMByid(llm_id) {
  return axios.get(`${this.url}/${llm_id}`);
 }



//  Tools API
 // get all tools
 fetchToolsByLLMid(llm_id,) {
  return axios.get(`${this.url}/${llm_id}/llm_tools`);
 }
 // get single tool by id
 fetchToolsByLLMid(llm_id,tool_id) {
  return axios.get(`${this.url}/${llm_id}/llm_tools/${tool_id}`);
 }

 // create tool
 createToolByLLMid(llm_id, data) {
  return axios.post(`${this.url}/${llm_id}/llm_tools`, data);
 }
//  update tool by llm id
 createToolByLLMid(llm_id,tool_id, data) {
  return axios.patch(`${this.url}/${llm_id}/llm_tools/${tool_id}`, data);
 }

 // llm call inbox
 fetchLLmCallInboxes() {
  return axios.get(`${this.url}/fetch_llm_inbox`);
 }

 // report
//  fetchAgentCallReport(queryParams) {
//     return axios.get(`${this.url}/reports`,{
//       params: queryParams,
//     });
//   }


}

export default new LLMChatbotAPI();
